module.exports = __webpack_public_path__ + "img/feature@2x.75622be1.jpg";